import * as React from "react"
import { cn } from "src/lib/utils";

const InputWithLabel = React.forwardRef(({ label,name, className, type, ...props }, ref) => {
  return (
      (
      <div className={cn("flex flex-col col-span-4 gap-2", className)}>
        <label htmlFor={name} className="col-span-1 text-sm text-gray-500 capitalize">{label}</label>
        <input 
          autoComplete="off" 
          type="text" name={name}  
          className="setupModal_input" 
          ref={ref} 
          {...props} />
      </div>
    )
  );
})
InputWithLabel.displayName = "InputWithLabel"

const InputWithInnerLabel = React.forwardRef(({children,hasChildren=false, label,labelClassName="",name, className, type,options, required=false, optionLabel,rows=4, autoSelectFirst=false , ...props}, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [inputType, setInputType] = React.useState(type);
  const togglePassword = (e) => {
    setShowPassword(!showPassword);
    setInputType(inputType === "password" ? "text" : "password");
  }
  
  switch (type) {
    case 'select':
      return (
        <div className={cn("relative w-full mt-1", className)}>
          <select name={name} 
          className={cn("rounded-md text-primary  py-2.5 border  border-gray-300 flex-1 block w-full pl-2 text-sm outline-none col-span-2 focus:border-vekin" )} 
          ref={ref} {...props} >

      {hasChildren? children : 
      <>
      {options?.length>1 && <option value={""}>{optionLabel || "select db server"}</option> }
      {options?.map((item,index)=>(
        <option key={`${index}_${name}`} value={item?.value} className="text-slate-500 ">{item?.label}</option>
      ))
      }
      </>}
          </select>
       
        <label htmlFor={name} className={cn("absolute px-0.5 text-xs capitalize bg-white rounded-md peer-focus:text-vekin left-2 peer-focus:font-medium text-slate-500 -top-2 ", required?"after:content-['*'] after:ml-0.5 after:text-red-500":"", labelClassName)}>{label}</label>
        <span className="absolute hidden text-[11px] text-red-400 -right-0 -top-4">Required</span>
      </div>
      )
    case 'password':
      return (
        <div className={cn("relative w-full mt-1", className)}>
        <input 
          required={required}
          autoComplete="off"
          type={inputType}
          name={name}  
          className={cn("rounded-md text-primary py-2.5 border  border-gray-300 peer flex-1 block w-full pl-2 text-sm outline-none col-span-2 focus:border-vekin", "&:not(:placeholder-shown):not(:focus):invalid~span]:block invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-400" )}
          ref={ref} 
          {...props} />
        
        <label htmlFor={name} className={cn("absolute  text-xs capitalize bg-white peer-focus:text-vekin left-2 peer-focus:font-medium text-primary -top-2 ", required?"after:content-['*'] after:ml-0.5 after:text-red-500":"", labelClassName)}>{label}</label>
        <button type="button" onClick={(e)=>togglePassword(e)} className="absolute right-2 top-[0.7rem]"><i className={showPassword?"ri-eye-off-line":"ri-eye-line"}></i></button>
        <span className="absolute hidden text-[11px] text-red-400 -right-0 -top-4">Required</span>
      </div>
      )
    case 'textarea':
      return (
        <div className={cn("relative w-full mt-1", className)}>
          <textarea
          rows={rows}
          name={name}
          className={cn("rounded-md resize-none text-primary py-2.5 border  border-gray-300 peer flex-1 block w-full pl-2 text-sm outline-none col-span-2 focus:border-vekin", "&:not(:placeholder-shown):not(:focus):invalid~span]:block invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-400" )}
          autoComplete="off"
          aria-describedby={label}
          ref={ref} 
          {...props}
          
          >
            
          </textarea>
       
        <label htmlFor={name} className={cn("absolute  text-xs capitalize bg-white peer-focus:text-vekin left-2 peer-focus:font-medium text-slate-500 -top-2 ", required?"after:content-['*'] after:ml-0.5 after:text-red-500":"",labelClassName)}>{label}</label>
        <span className="absolute hidden text-[11px] text-red-400 -right-0 -top-4">Required</span>
      </div>
      )
 
    default:
      return (
        <div className={cn("relative w-full mt-1", className)}>
        <input 
          required={required}
          autoComplete="off"
          aria-describedby="passwordHelp"
          type="text" name={name}  
          className={cn("rounded-md disabled text-primary py-2.5 border read-only:border-0 read-only:cursor-not-allowed disabled:text-slate-500 border-gray-300 peer flex-1 block w-full pl-2 text-sm outline-none col-span-2 focus:border-vekin read-only:focus:border-gray-300", "&:not(:placeholder-shown):not(:focus):invalid~span]:block invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-400" )}
          ref={ref} 
          {...props} />
        <label htmlFor={name} className={cn("absolute  text-xs capitalize bg-white peer-focus:text-vekin  left-2 peer-focus:font-medium text-slate-500 -top-2 ", required?"after:content-['*'] after:ml-0.5 after:text-red-500":"", labelClassName)}>{label}</label>
        <span className="absolute hidden text-[11px] text-red-400 -right-0 -top-4">Required</span>
      </div>
      )
  }
})
InputWithInnerLabel.displayName = "InputWithInnerLabel"

export { InputWithLabel, InputWithInnerLabel }


